import { useEffect, useState } from "react";

/** True depois que a página rolar além de `offset` — encolhe o cabeçalho fixo. */
export function useScrolledPast(offset: number): boolean {
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const update = () => setScrolled(window.scrollY > offset);
		update();
		window.addEventListener("scroll", update, { passive: true });
		return () => window.removeEventListener("scroll", update);
	}, [offset]);

	return scrolled;
}
